<template>
  <BaseModal
    v-if="isPricingPayAsYouGo"
    :id="id"
    :modalClass="`modal-md`"
    :headerText="headerText"
    :showCloseButton="false"
    @onClose="handleClose"
  >
    <template #body>
      <div class="container-body">
        <div class="unit-price">{{ bodyTextUnitPrice }}</div>
        <div class="per-month">{{ bodyTextPerMonth }}</div>
      </div>
    </template>
    <template #footer>
      <div class="container-footer">
        <span>
          <a
            :href="`https://www.treesoft.io/${lang}/pricing`"
            target="_blank">
            {{ $t('button.learnmore') }}
            <i class="fas fa-external-link-alt"/>
          </a>
        </span>
        <div>
          <button
            type="button"
            class="btn btn-light btn-view-service-used"
            @click="onClickViewServiceUse">
            {{ $t('button.viewserviceused') }}
          </button>
          <button
            type="button"
            class="btn btn-web"
            @click="onClickClose">
            {{ $t('button.close') }}
          </button>
        </div>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    id: {
      type: String,
      default: null,
    },
    headerText: {
      type: String,
      default: null,
    },
    bodyTextUnitPrice: {
      type: String,
      default: null,
    },
    bodyTextPerMonth: {
      type: String,
      default: null,
    },
  },

  computed: {
    ...mapGetters({
      lang: 'getLang',
    }),
  },

  methods: {
    handleClose () {
      this.$emit('onClose')
    },
    onClickClose () {
      $(`#${this.id}`).modal('hide')
      this.$emit('onClose')
    },
    onSelect (event, item) {
      this.$emit('onSelect', item)
    },
    onClickViewServiceUse () {
      this.$router.push({ name: 'BillingServiceUsed' })
    },
  },
}
</script>

<style scoped>
.container-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 9px;
}

.unit-price {
  font-size: 24px;
}

.per-month {
  margin-top: 10px;
  font-size: 14px;
}

.container-footer {
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.btn-view-service-used {
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/base/BaseModalOverLimit.vue